module.exports = __webpack_public_path__ + "media/images/newsletter/newsletter-perks-and-rec-098ccb7812a79bb4133aad4248d01915.png";